import { ConfigFn } from '@config/types'

const config = (({ publication, searchUrl }) => {
  const entitiesBaseUrl = `${searchUrl}/entities?pub=${publication}` as const

  return {
    entitiesBaseUrl,
    sportEntitiesBaseUrl: `${entitiesBaseUrl}&isSportEntity=true`,
  } as const
}) satisfies ConfigFn

export default config
